// extracted by mini-css-extract-plugin
module.exports = {"pin":"_2787e5dfdf--pin--_9gqe","balloon":"_2787e5dfdf--balloon--Vhf4b","price":"_2787e5dfdf--price--yu7Cg","count":"_2787e5dfdf--count--ppWcS","point":"_2787e5dfdf--point--szKsK"};